// MovieControlView.js
import $ from 'jquery';
import { View } from 'backbone';

import BaseControlView from 'BaseControlView.js';
import constants        from "Constants.js";
import template from 'advanced-visuals/control_movie.ejs';
//=====================================================================
//
// An instance of this view represents a Movie control.
//
// Brad Trebilcock, February, 23 2016
//
//=====================================================================
class MovieControlView extends BaseControlView  {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';

        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'MovieControlView';
    }


}

export default MovieControlView;

